// FF-DOCK-3 — sidebar mini-panel actions (Ask open + tour start + return floating).

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import type { ActivityDockAssistLevel } from "@/lib/activityDock/assistLevel";
import {
  buildFireflyTourRequestEventDetail,
  emitFireflyTourRequestEvent,
} from "@/lib/firefly/fireflyTourRequestEvent";
import { invokeFireflyTourStarter } from "@/lib/firefly/fireflyTourStartBridge";
import type { FireflyTourArtifact } from "@/lib/firefly/tourTypes";
import { setFireflyDisplayMode } from "@/lib/firefly/fireflyDisplayMode";

/** Open the shared attention panel and expand Ask. */
export function openAskFireflyFromSidebarDock(): void {
  void import("@/components/activity/activityDockOpenEvent").then((m) => {
    void m.openFireflyActivityDock({ force: true, expandAsk: true });
  });
}

/** Open Activity dock on Messages (undocks with travel when sidebar-docked). */
export function openMessagesFromSidebarDock(): void {
  void import("@/components/activity/activityDockOpenEvent").then((m) => {
    void m.openFireflyActivityDock({ force: true, focusSection: "messages" });
  });
}

/** Open full Activity dock (undocks with travel when sidebar-docked). */
export function openActivityFromSidebarDock(): void {
  void import("@/components/activity/activityDockOpenEvent").then((m) => {
    void m.openFireflyActivityDock({ force: true });
  });
}

export function returnFireflyToFloating(_opts?: { animate?: boolean }): void {
  setFireflyDisplayMode("floating");
}

/** House Firefly inside the notification bell and hide the floating tab. */
export function dockFireflyInSidebar(_opts?: { animate?: boolean }): void {
  setFireflyDisplayMode("docked");
}

export function startFireflyTourFromSidebarDock(input: {
  artifact: FireflyTourArtifact;
  currentMode: PrimaryMode;
  assistLevel: ActivityDockAssistLevel;
  nowMs?: number;
}): void {
  const { artifact, currentMode, assistLevel } = input;
  const nowMs = input.nowMs ?? Date.now();
  emitFireflyTourRequestEvent(
    buildFireflyTourRequestEventDetail({
      tourId: artifact.id,
      trigger: "catalog",
      intent: artifact.defaultIntent,
      mode: currentMode,
      targetMode: artifact.steps[0]?.target.mode,
      outcome: "started",
      assistLevel,
      nowMs,
      inputModality: "text",
    }),
  );
  invokeFireflyTourStarter(artifact, "catalog");
}
